import { UrlConstants } from "../url.constants";
export class ApiTrainingConstants {
    static URL = UrlConstants.API_V2 + "TrainingModule";
    static FUNCTION_SET_APPLICANT_AND_APPLICANT_AGENT = "SetApplicantAndApplicantAgent";
    static FUNCTION_GET_MY_AFLA_PORTAL_TRAINING_APPLICATIONS = "GetAflaPortalTrainingModuleApplications";
    static FUNCTION_GET_ALL_AFLA_PORTAL_TRAINING_APPLICATIONS = "GetAllAFLAPortalTrainingApplications";
    static FUNCTION_CREATE_PARTIAL_APPLICATION = "CreatePartialPortalTrainingModuleApplication";
    static FUNCTION_CREATE_RESUBMITTED_APPLICATION = "CreateResubmittedPortalTrainingModuleApplication";
    static FUNCTION_APPLICATION_TYPES = "GetTmApplicationTypes";
}
